import React from 'react';
import { connect } from 'react-redux';
import { AppState } from '../../../../reducers';

import LoginPromoModal from '../../../../components/modal/login-promo';
import ProductAlertForm from '../product-alert-form';
import ProductAlertInfo from '../product-alert-info';
import { createAlertRequest as createAlertRequestAction } from '../../../sidebar/actions/alert';
import { ProductAlertFormData } from '../../types';

type OnCreate = () => void;

type CreateAlertRequest = (data: object, onSuccess: OnCreate) => void;

interface CreateAlertProps {
  productAlertFormData: ProductAlertFormData;
  createAlertRequest: CreateAlertRequest;
  sending?: boolean;
  error?: boolean | string;
  privacyPolicyUri?: string;
  showCancel?: boolean;
  onCreate?: OnCreate;
  withoutGraph?: boolean;
}

const CreateAlert = (props: CreateAlertProps) => {
  const {
    productAlertFormData,
    sending,
    error,
    createAlertRequest,
    privacyPolicyUri,
    showCancel = true,
    onCreate = () => {},
    withoutGraph,
  } = props;

  const [showLoginPromo, setShowLoginPromo] = React.useState<boolean>(false);

  return (
    <>
      <LoginPromoModal
        isOpen={showLoginPromo}
        onRequestClose={() => setShowLoginPromo(false)}
      />
      <ProductAlertInfo productAlertFormData={productAlertFormData} />
      <ProductAlertForm
        productAlertFormData={productAlertFormData}
        disabled={sending}
        error={error}
        onCreate={productAlert => createAlertRequest(productAlert, onCreate)}
        privacyPolicyUri={privacyPolicyUri}
        showCancel={showCancel}
        shouldAutoFocus
        openLoginPromo={() => setShowLoginPromo(true)}
        withoutGraph={withoutGraph}
      />
    </>
  );
};

const mapStateToProps = (state: AppState) => ({
  sending: state.areas.productAlert.sending,
  error: state.areas.productAlert.error,
});

const dispatchActions = {
  createAlertRequest: createAlertRequestAction,
};

export default connect(mapStateToProps, dispatchActions)(CreateAlert);
